import clsx from 'clsx'
import React from 'react'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import BrandLogoGifImage from '../../assets/imgs/brand-logo.gif'
import { Button, HomeLayout, Input } from '../../components'
import { isDesktop } from '../../utils'
import { login } from '../../store/user'

import './Login.scss'

const Login = () => {
   const history = useHistory()
   const dispatch = useDispatch()
   const { isAuthenticated } = useSelector(state => state.user)
   const { isDarkTheme } = useSelector(state => state.theme)
   const [password, setPassword] = React.useState('')
   const { privateKeyEncrypted } = useSelector(state => state.user)

   React.useEffect(() => {
      if (isAuthenticated) {
         history.push('/home')
      }
   }, [isAuthenticated, history])

   const handleSubmit = async() => {
      try {
         let response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/auth/restoreAccount`,
            {
               downloadKey: privateKeyEncrypted,
               password: password,
            }
         )

         if (response.status === 200) {
            dispatch(
               login({
                  privateKey: response.data.privateKey,
                  publicKey: response.data.publicKey,
                  privateKeyEncrypted: privateKeyEncrypted,
               })
            )
            history.push('/home')
         } else {
            console.log('Failed to restore: ', response.data.message)
         }
      } catch (err) {
         console.log('Failed to restore: ', err.message)
      }
   }

   if (isDesktop()) {
      return (
         <HomeLayout>
            <div
               className={clsx(
                  'DesktopLogin',
                  isDarkTheme && 'DesktopLogin--dark'
               )}
            >
               <div className="DesktopLogin__card">
                  <h2 className="DesktopLogin__heading">Welcome Back!</h2>
                  <div className="DesktopLogin__gif-container">
                     <img
                        alt="WallStreetNinja"
                        className="DesktopLogin__gif"
                        src={BrandLogoGifImage}
                     />
                  </div>
                  <form className="DesktopLogin__form">
                     <Input
                        className="DesktopLogin__form-input"
                        placeholder="Password"
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        isDarkTheme={isDarkTheme}
                     />
                     <Button
                        className="DesktopLogin__form-cta"
                        variant="solid"
                        color="primary"
                        onClick={() => handleSubmit()}
                        size="lg"
                        isDarkTheme={isDarkTheme}
                     >
                        Log In
                     </Button>
                  </form>
               </div>
            </div>
         </HomeLayout>
      )
   }

   return (
      <HomeLayout>
         <main className={clsx('Login', isDarkTheme && 'Login--dark')}>
            <h2 className="Login__heading">Welcome Back!</h2>
            <div className="Login__gif-container">
               <img
                  alt="WallStreetNinja"
                  className="Login__gif"
                  src={BrandLogoGifImage}
               />
            </div>
            <form className="Login__form">
               <Input
                  className="Login__form-input"
                  placeholder="Password"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  isDarkTheme={isDarkTheme}
               />
               <Button
                  className="Login__form-cta"
                  variant="solid"
                  color="primary"
                  onClick={() => handleSubmit()}
                  isDarkTheme={isDarkTheme}
               >
                  Log In
               </Button>
            </form>
         </main>
      </HomeLayout>
   )
}

export default Login
